module.exports = __webpack_public_path__ + "static/media/bg1.517a6e05.png";